import React from "react";
import PropTypes from "prop-types";
import Pagination from "react-js-pagination";
import { Button, Glyphicon } from "react-bootstrap";
import PerPageSelect from "./PerPageSelect";
import RunsheetUpload from "./RunsheetUpload";

const Footer = ({
  page,
  pageSize,
  totalRunsheets,
  handlePageChange,
  handlePerPageChange
}) => (
  <div className="footer navbar-fixed-bottom">
    <div className="footer-display">
      <div>
        <span className="per-page-text">Rows per page </span>
        <div className="per-page-select">
          <PerPageSelect
            perPage={pageSize}
            handleChange={handlePerPageChange}
          />
        </div>
      </div>
      <div>
        {totalRunsheets > pageSize ? (
          <Pagination
            activePage={page}
            itemsCountPerPage={pageSize}
            totalItemsCount={totalRunsheets}
            onChange={handlePageChange}
          />
        ) : (
          ""
        )}
      </div>
      <div>
        <div className="display-inline">
          <Button href="/runsheets/new" className="btn btn-default">
            <Glyphicon glyph="plus" /> Add New Runsheet
          </Button>
        </div>{" "}
        <div className="display-inline">
          <RunsheetUpload />
        </div>
      </div>
    </div>
  </div>
);
Footer.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalRunsheets: PropTypes.number.isRequired,
  handlePerPageChange: PropTypes.func.isRequired,
  handlePageChange: PropTypes.func.isRequired
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/Footer.js